import api from '../../services/api';
import {
  clearAuthTokens,
  getAccessToken,
  hasStoredSession,
  persistAuthTokens,
} from '../../services/authTokens';
import { refresh } from './authApi';
import { setLoading, setUser } from './authSlice';

/**
 * Rehydrate Redux auth from persisted tokens (and/or refresh cookie) on boot.
 * Must finish before AuthGuard redirects unauthenticated users to /login.
 */
export async function bootstrapAuth(dispatch) {
  try {
    if (!hasStoredSession()) return;

    const accessToken = getAccessToken();
    if (accessToken) {
      // Valid access → /users/me. Expired access → axios interceptor refreshes then retries.
      const { data } = await api.get('/users/me');
      dispatch(setUser(data));
      return;
    }

    // Bearer mode with refresh token only (access missing/cleared)
    const result = await refresh();
    persistAuthTokens(result);
    dispatch(setUser(result.user));
  } catch (_) {
    clearAuthTokens();
    dispatch(setUser(null));
  } finally {
    dispatch(setLoading(false));
  }
}
